export default "__VITE_ASSET__DzGNNnIn__"